import React from "react";
import { Link } from "react-router-dom";
import useMenuLogic from "./Menu.logic";

const Menu: React.FC = () => {
  const {
    isCurrentPath,
    isAuthenticated,
    showMyEvents,
    showManageEvents,
    showAdminMenu,
  } = useMenuLogic();

  return (
    <ul className="main-menu__list">
      {showAdminMenu ? (
        <>
          <li className={`${isCurrentPath("/admin", true) ? "current" : ""}`}>
            <Link to="/admin">Admin Dashboard</Link>
          </li>
          <li
            className={`${
              isCurrentPath("/admin/reports", true) ? "current" : ""
            }`}
          >
            <Link to="/admin/reports">Reports</Link>
          </li>
          <li
            className={`${
              isCurrentPath("/admin/blacklist", true) ? "current" : ""
            }`}
          >
            <Link to="/admin/blacklist">Blacklists</Link>
          </li>
          <li
            className={`${
              isCurrentPath("/admin/manage") ? "current" : ""
            } dropdown`}
          >
            <Link to="#">Manage</Link>
            <ul>
              <li
                className={`${
                  isCurrentPath("/admin/manage/ngos") ? "current" : ""
                }`}
              >
                <Link to="/admin/manage/ngos">NGOs</Link>
              </li>
              <li>
                <Link to="/admin/manage/interests">Interests</Link>
              </li>
              <li>
                <Link to="/admin/manage/causes">Causes</Link>
              </li>
            </ul>
          </li>
        </>
      ) : (
        <>
          <li className={`${isCurrentPath("/") ? "current" : ""}`}>
            <Link to="/">Home</Link>
          </li>
          <li
            className={`${
              (isCurrentPath("/events") ? "current" : "") +
              (isAuthenticated ? " dropdown" : "")
            }`}
          >
            <Link to="/events">Events</Link>
            {isAuthenticated && (
              <>
                <ul>
                  <li>
                    <Link to="/events?filter=discover">Discover</Link>
                  </li>
                  {showMyEvents && (
                    <li>
                      <Link to="/events?filter=my-events&view=my-events">
                        My Events
                      </Link>
                    </li>
                  )}
                  {showManageEvents && (
                    <li>
                      <Link to="/events?filter=admin-events&view=admin-events">
                        Manage All Events
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/events/add">Host a New Event</Link>
                  </li>
                </ul>
              </>
            )}
          </li>
          <li className={`${isCurrentPath("/ngos") ? "current" : ""}`}>
            <Link to="/ngos">NGOs</Link>
          </li>
          <li>
            <Link to="/about">About Us</Link>
          </li>
          {/* <li>
            <Link to="/contact">Contact Us</Link>
          </li> */}
        </>
      )}
    </ul>
  );
};

export default Menu;
